"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockOrderClient = void 0;
exports.MockOrderClient = {
    submitOrder: function (order) {
        console.log("Order: " + JSON.stringify(order));
        return Promise.resolve({ orderId: "sad1og8v0sski0e6zkx", intentId: "sdfisdg4efdfg" });
    },
    getOrdersForLocation: function (locationId, _authToken) {
        return Promise.resolve([mockOrder(locationId)]);
    },
    cancelOrder: function () {
        var response = new Response(null, { status: 204 });
        return Promise.resolve(response);
    }
};
var mockOrder = function (locationId) { return ({
    "isActive": "Y",
    "totalCost": 1000,
    "totalCostExVat": 800,
    "orderStatus": "NEW",
    "orderId": "sad1og8v0sski0e6zkx",
    "locationId": locationId,
    "menuId": "fsd0nzmalpg7dd",
    "destination": "sdfn03nf3nfop28v3",
    "items": {
        "erger4ys5": {
            itemId: "erger4ys5",
            productId: "3",
            section: "mains",
            product: {
                id: "3",
                name: 'Japanese style bubble coated prawns',
                description: 'Green chilli & lime dip',
                sizes: [{ name: "medium", price: 700, priceExVat: 583, vatApplied: 117 }],
                vatPercent: 20,
                category: {
                    displayCategory: "mains",
                    kitchenCategory: "mains",
                    tags: []
                },
                available: true,
            },
            quantity: 2,
            completed: false,
            size: { name: "medium", price: 700, priceExVat: 583, vatApplied: 117 }
        },
        "fsd3fspvld": {
            itemId: "fsd3fspvld",
            productId: "6",
            section: "mains",
            product: {
                id: "6",
                name: 'Penang chicken curry',
                description: 'Served with basmati rice and naan bread',
                sizes: [{ name: "medium", price: 1200, priceExVat: 1000, vatApplied: 200 }],
                vatPercent: 20,
                category: {
                    displayCategory: "mains",
                    kitchenCategory: "mains",
                    tags: []
                },
                available: true
            },
            quantity: 3,
            completed: false,
            size: { name: "medium", price: 1200, priceExVat: 1000, vatApplied: 200 },
        },
    },
    "orderPlacedDateTimeUtc": 1606489204,
    "customer": {
        name: "Jack",
        destination: "Table 7"
    }
}); };
